/**
 * Root route — every page renders inside this layout (SCH Milestone A).
 *
 * Layout is `<Outlet />` plus the things that must reach EVERY route. App chrome
 * is opt-in via `<LearnShell>` / `<ParentShell>` (login/signup render chrome-free),
 * so this file is the only place a global affordance can be mounted without leaving
 * routes uncovered — the quiz screen, for one, has no shell.
 *
 * #567: `<ActiveTimeBeat>` records a signed-in person's foreground, non-idle time,
 * one beat a minute. The server decides whether it counts as student or staff time.
 */
import { createRootRoute, Outlet } from '@tanstack/react-router';
import { useActiveTime } from '@mangrove/ui';
import { trpc } from '../lib/trpc.js';

export const Route = createRootRoute({
  component: RootLayout,
});

function ActiveTimeBeat(): null {
  const me = trpc.auth.getCurrentUser.useQuery(undefined, { retry: false });
  const beat = trpc.learning.learner.activity.beat.useMutation();
  // `useActiveTime` keeps the latest callback in a ref, so an inline one is fine.
  useActiveTime((seconds) => beat.mutate({ seconds }), { enabled: Boolean(me.data?.tenantId) });
  return null;
}

function RootLayout(): React.JSX.Element {
  return (
    <>
      <ActiveTimeBeat />
      <Outlet />
    </>
  );
}
